import { mapGetters } from 'vuex';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';

export default {
    components: {
        mvtHotleadForm,
    },
    name: 'agentConnect',
    inject: ['$eventBus'],
    props: {
        hotleadType: {
            type: String,
            default: 'PopupHotleadInAgentProfilePage_seller',
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getPhoneNumber', 'getSplit']),
        hotleadOpt() {
            return {
                hotleadSup: 'GET STARTED',
                hotleadTitle: `Connect now with a top ${this.glb.pageType === 'vagenthome' ? 'local' : this.glb.geo.city} agent`,
                hotleadType: this.hotleadType,
                buttonText: 'Connect Now',
                showGeo: true,
                hideProfile: true,
            };
        },
    },
};
